export default "__VITE_PUBLIC_ASSET__f553be6f__"